import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CustomDrawerHeader from './CustomDrawerHeader';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';

const drawerWidth = 240;
const heightMenu = 64;

const useStyles = makeStyles((theme) => ({
    main: {
        alignItems: 'center',
        marginLeft: `calc(${theme.spacing(9)} + 1px)`,
        marginTop: heightMenu,
        [theme.breakpoints.down('md')]: {
            // marginLeft: `calc(${theme.spacing(7)} + 1px)`,
            // width:`calc(100% - ${theme.spacing(21)} + 1px)`,
            marginLeft: 0,
            width: '100%',
        },
    },
    main_menu_open: {
        marginLeft: drawerWidth,
        marginTop: heightMenu,
    },
}));

export default function CustomContainer(props) {
    const classes = useStyles();
    const {open} = props;

    return (
        <Box component="main" className={classNames(open ? classes.main_menu_open : classes.main)}>
            {props.children}
        </Box>
    );
}